import { Grid, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	subtitleCategoryDepartureMenSX,
	titleCategoryDepartureMenSX,
} from '@/components/blocks/DpLibrary/DpDepartmentCard/style';
import { Linkable } from '@/components/blocks/Linkable';

interface DpDepartmentCardProps {
	title: string;
	subtitle: string;
	image: string;
	href?: string;
}

export const DpDepartmentCard: React.FC<DpDepartmentCardProps> = ({
	title,
	subtitle,
	image,
	href,
}) => (
	<Grid item xs={12} md={4}>
		<Linkable href={href}>
			<Img src={image} width={'100%'} height={'500px'} sx={{ objectFit: 'cover' }} />
			<Typography component={'h3'} sx={titleCategoryDepartureMenSX}>
				{title}
			</Typography>
			<Typography sx={subtitleCategoryDepartureMenSX}>{subtitle}</Typography>
		</Linkable>
	</Grid>
);

